import React from 'react';
import Stack from '@mui/material/Stack';
import { Chip } from '@routific/hive/v5';

interface TagsRowProps {
  tags: string[];
  prefix?: React.ReactNode;
}

const TagsRow: React.FC<TagsRowProps> = ({ tags, prefix }) => {
  if (!tags.length) return null;

  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      useFlexGap
      sx={{ flexWrap: 'wrap' }}
      data-testid="tags-row"
    >
      {prefix}
      {tags.map((tag) => (
        <Chip
          key={tag}
          size="sm"
          data-testid={`tag-${tag}`}
        >
          {tag}
        </Chip>
      ))}
    </Stack>
  );
};

export default TagsRow;
